import { render, staticRenderFns } from "./PanelSetting.vue?vue&type=template&id=1db93b68&scoped=true&"
import script from "./PanelSetting.vue?vue&type=script&lang=js&"
export * from "./PanelSetting.vue?vue&type=script&lang=js&"
import style0 from "./PanelSetting.vue?vue&type=style&index=0&id=1db93b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db93b68",
  null
  
)

export default component.exports